import { getCurrency } from "@coras-io/embed/helpers";
import { site } from "./config";

const origin = `https://${site.domain}`;

function indexedCurrency(locale: string): string {
  const preferred = site.detectCurrency ? getCurrency(locale) : site.currency;
  return (site.currencies as readonly string[]).includes(preferred)
    ? preferred
    : site.currency;
}

function pagePath(pathname: string, locale: string, currency: string): string {
  const prefix = `/${locale}/${currency}`;
  const page = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : "";
  return page.replace(/\/+$/, "");
}

export function localisedLinks(
  pathname: string,
  locale: string,
  currency: string,
): Array<{ rel: string; href: string; hrefLang?: string }> {
  const page = pagePath(pathname, locale, currency);
  const url = (forLocale: string) =>
    `${origin}/${forLocale}/${indexedCurrency(forLocale)}${page}`;

  return [
    { rel: "canonical", href: url(locale) },
    ...site.locales.map((alternate) => ({
      rel: "alternate",
      hrefLang: alternate,
      href: url(alternate),
    })),
    { rel: "alternate", hrefLang: "x-default", href: url(site.locale) },
  ];
}
